module.exports = __webpack_public_path__ + "static/img/vacuumImg.d04af04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/vacuumImg.png
// module id = gXOg
// module chunks = 1